<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Sdwan from './sdwan'

export default {
  page: {
    title: 'SD-WAN Monitoring',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: { Layout, PageHeader, Sdwan },
  data () {
    return {
      title: 'SD-WAN',
      items: [
        {
          text: 'Home',
          href: '/'
        },
        {
          // Plain text: b-breadcrumb renders an item without href as href="#".
          text: 'Monitoring',
          active: true
        },
        {
          text: 'SD-WAN',
          active: true
        }
      ]
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
    />
    <div class="row">
      <div class="col-12">
        <b-alert
          show
          variant="warning"
          class="d-flex align-items-center py-1"
        >
          <feather
            type="alert-triangle"
            class="icon-xs mr-2"
          />
          <span>
            <b>Pilot data.</b> The SD-WAN collector is running in demo/pilot mode;
            metrics and events are indicative and may vary by firewall firmware.
          </span>
        </b-alert>
      </div>
    </div>
    <Sdwan :base-path="'/monitoring/sdwan'" />
  </Layout>
</template>
